import { UpdateMenuMetaForm } from "./UpdateMenuMetaForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { getMenuDetails, getMenuHeaderMembers } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { useTranslation } from "react-i18next";
import { LoadingSmall } from "@/components/LoadingSmall";
import { DeleteMenuButton } from "./DeleteMenuButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";
import { UpdateMenuApiPermissions } from "./UpdateMenuApiPermissions";

export const MenuDetailPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const menuId = searchParams.get("Id");

  const { data: menuDetails, isLoading } = useQuery({
    queryKey: ["getMenuDetails", menuId],
    queryFn: () => getMenuDetails(Number(menuId)),
  });

  const menuDetailsData = menuDetails?.data;

  const { data: menuHeaderMembers, isLoading: isMenuHeaderMembersLoading } = useQuery({
    queryKey: ["getMenuHeaderMembers", menuId],
    queryFn: () => getMenuHeaderMembers(Number(menuId)),
  });

  useBreadcrumbs([
    {
      name: t("entities.menu"),
      path: ROUTES.MENU,
    },
    {
      name: menuDetailsData?.menuName ?? "...",
      path: ROUTES.MENU_DETAIL,
    },
  ]);

  if (!menuDetailsData || isLoading || isMenuHeaderMembersLoading) {
    return <LoadingSmall />;
  }

  return (
    <BaseFormLayout title={t("common.detail")} rightContent={<DeleteMenuButton menuId={menuDetailsData.id} />}>
      <Tabs defaultValue="meta">
        <TabsList>
          <TabsTrigger value="meta">{t("common.detail")}</TabsTrigger>
          <TabsTrigger value="rights">API {t("common.rights")}</TabsTrigger>
        </TabsList>
        <TabsContent value="meta">
          <UpdateMenuMetaForm menuDetails={menuDetailsData} menuHeaderMember={menuHeaderMembers?.data.result?.[0]} />
        </TabsContent>
        <TabsContent value="rights">
          <UpdateMenuApiPermissions menuDetails={menuDetailsData} />
        </TabsContent>
      </Tabs>
    </BaseFormLayout>
  );
};
